<template>
  <tile>
    <div class="header">
      <p class="title">Your Refinance Details</p>
    </div>
    <div v-if="gettingData"><Loader /></div>
    <div v-else class="application-info-content-wrapper">
      <div class="loans-to-refinance-section-wrapper">
        <LoansToRefinanceTable
          :showIncludedLoansOnly="true"
          :showAddLoanButton="false"
          id="ApplicationInfoTile"
        ></LoansToRefinanceTable>
      </div>
      <RefiLoanConfigurationDetails></RefiLoanConfigurationDetails>
    </div>
  </tile>
</template>
<script setup lang="ts">
import Tile from "@/components/shared/Tile.vue";
import { defineProps, onMounted, computed, ref } from "vue";
import { useStore } from "vuex";
import LoansToRefinanceTable from "@/components/refi-loans-table/LoansToRefinanceTable.vue";
import RefiLoanConfigurationDetails from "@/components/refi-loan-configuration/RefiLoanConfigurationDetails.vue";
import Loader from "@/components/shared/Loader.vue";
import { ApplicationStatusTypeIds } from "@/config/constants";

const props = defineProps({
  application: {
    type: Object,
    required: true,
  },
});

const store = useStore();

const gettingData = ref<boolean>(true);

const applicationStatusId = computed(() => store.state.appData?.application?.applicationStatusId);
const currentApplicant = computed(() => store.state.appData?.currentApplicant);

async function getRefiDetails() {
  await store.dispatch("applicationInfoModule/getRefiDetails", props.application?.id);

  if (
    applicationStatusId.value === ApplicationStatusTypeIds.SUBMITTED_AND_PROCESSING ||
		applicationStatusId.value === ApplicationStatusTypeIds.RIGHT_TO_CANCEL ||
    applicationStatusId.value === ApplicationStatusTypeIds.COMPLETE
  ) {
    store.dispatch("consentsModule/setCurrentApplicant", currentApplicant.value);
    await store.dispatch("consentsModule/getConsentsForAllApplicants");
  }

  gettingData.value = false;
}

onMounted(() => {
  getRefiDetails();
});
</script>
<style scoped>
.header .title {
  font-weight: 700;
  font-size: 1.25rem;
}

.application-info-content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1em;
}
</style>
<style>
a {
  text-decoration: underline;
  cursor: pointer;
}
</style>
